module.exports = __webpack_public_path__ + "static/media/final_01.314bec47.jpg";